
// import React, { useState, useEffect } from 'react';

// const FLAGSHIP_IMAGES = [
//   "https://assocham.org/assets/images/1739943966_SMK_2.0_ASSOCHAM%20Web%20Banner_650%20X%20914%20pixels.jpg",
//   "https://assocham.org/assets/images/1772536051_Untitled%20design.jpg",
//   "https://assocham.org/assets/images/1770812319_IMG-20260211-WA0043.jpg",
// ];

// const PODCAST_VIDEOS = [
//   { id: "7YJxHDBBfWg", title: "Podcast Title 1 - ASSOCHAM Insights" },
//   { id: "tGG56vaD0Gc", title: "Podcast Title 2 - Economy & Growth" },
//   { id: "Y7Rl-e_yJUk", title: "Podcast Title 3 - Industry Leaders Speak" },
//   { id: "pl3r5yT6I-0", title: "Podcast Title 4 - Future of Indian Business" },
//   { id: "Iwbt2yZaKSc", title: "Podcast Title 5 - Policy & Reforms" },
// ];

// const UPCOMING_EVENTS = [
//   {
//     image: "https://startupmahakumbh.org/assets/img/Logo-1.webp",
//     month: "FEB",
//     date: "12-14",
//     title: "Startup Mahakumbh 2026",
//     location: "Bharat Mandapam, New Delhi"
//   },
//   {
//     image: "https://imgs.search.brave.com/NcI33rhygqZ1vWiqnhAyO5ad-ismIwvH56zn8jJPfzs/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9pY2do/LmluL2xvZ2luL2lt/YWdlcy9CYW5uZXJf/LmpwZw",
//     month: "JAN",
//     date: "22",
//     title: "National Summit on Green Hydrogen",
//     location: "Mumbai"
//   },
//   {
//     image: "https://imgs.search.brave.com/l9z5OGjIl1j3ZkvgbWN_aoeX6ziQenCcoEHkdBst43o/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9kMS5h/d3NzdGF0aWMuY29t/L29uZWRhbS9tYXJr/ZXRpbmctY2hhbm5l/bHMvd2Vic2l0ZS9h/d3MvZW5fVVMvZXZl/bnRzL2FwcHJvdmVk/L2ltYWdlcy9hd3Mt/YWktY29uY2xhdmUt/MjYtdmlkZW8uMWIx/NmE2Zjg3YWUzNGM0/YmE2N2JmYWU3OTM5/NWY3ZWM2ZTQ1ZTFh/My5qcGc",
//     month: "MAR",
//     date: "05",
//     title: "Global AI Conclave 2026",
//     location: "Bengaluru"
//   },
//   {
//     image: "https://imgs.search.brave.com/s2KhPbYH_EuzKkJOBABX-h8SL_AKTXxM2Zyz6QQNpzY/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly93d3cu/c3lubmV4Z3JvdXAu/Y29tL3dwLWNvbnRl/bnQvdXBsb2Fkcy8y/MDI1LzA1L1RodW1i/bmFpbC0xNS0xLXNj/YWxlZC5qcGc",
//     month: "APR",
//     date: "15-16",
//     title: "India Manufacturing Summit 2026",
//     location: "Hyderabad International Convention Centre"
//   }
// ];

// const FlagshipAndEvent = () => {
//   const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
//   const [isPlaying, setIsPlaying] = useState(false);
//   const [isHoveringPodcast, setIsHoveringPodcast] = useState(false);

//   const [currentFlagshipIndex, setCurrentFlagshipIndex] = useState(0);
//   const [flagshipProgress, setFlagshipProgress] = useState(0);

//   const currentVideo = PODCAST_VIDEOS[currentVideoIndex];

//   // Auto Slider for Podcast
//   useEffect(() => {
//     const interval = setInterval(() => {
//       if (!isHoveringPodcast) {
//         setCurrentVideoIndex((prev) => (prev + 1) % PODCAST_VIDEOS.length);
//         setIsPlaying(false);
//       }
//     }, 5000);
//     return () => clearInterval(interval);
//   }, [isHoveringPodcast]);

//   // Auto Slider for Flagship Images
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setFlagshipProgress((prev) => {
//         if (prev >= 100) {
//           setCurrentFlagshipIndex((prevIndex) => (prevIndex + 1) % FLAGSHIP_IMAGES.length);
//           return 0;
//         }
//         return prev + 2;
//       });
//     }, 100);
//     return () => clearInterval(interval);
//   }, []);

//   const handleVideoClick = () => {
//     setIsPlaying(!isPlaying);
//   };

//   return (
//     <div className="bg-[#fff8f5] py-12 px-4 font-sans">
//       <div className="mx-auto text-center mb-10">
//         <h1 className="text-[26px] md:text-[28px] font-semibold leading-tight text-gray-900 font-rethink">
//           <span className="text-[#da2128]">ASSOCHAM</span> Voice & Events
//         </h1>
//         <p className="text-[14px] text-gray-600 mt-3 max-w-2xl mx-auto leading-relaxed font-rethink">
//           Stay updated with the latest discussions, upcoming programs and flagship initiatives.
//         </p>
//       </div>

//       <div className="mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 items-stretch">
        
//         {/* LEFT: PODCAST - VIDEO CHHOTA Kiya */}
//         <div className="lg:col-span-4 bg-[#ffffff] rounded-3xl shadow-xl flex flex-col h-[520px] overflow-hidden">
//           <div className="p-3 border-b">
//             <h3 className="text-[18px] font-semibold text-[#da2128] font-rethink">
//               ASSOCHAM Voice Podcast
//             </h3>
//           </div>

//           {/* Video Container - Height Reduced */}
//           <div 
//             className="px-5 pt-4 pb-3 bg-[#FFFFFF] cursor-pointer"
//             onMouseEnter={() => setIsHoveringPodcast(true)}
//             onMouseLeave={() => setIsHoveringPodcast(false)}
//             onClick={handleVideoClick}
//           >
//             <div className="relative rounded-2xl overflow-hidden shadow-md h-[240px] bg-black ring-1 ring-gray-200">
//               {isPlaying ? (
//                 <iframe
//                   width="100%"
//                   height="100%"
//                   src={`https://www.youtube.com/embed/${currentVideo.id}?autoplay=1&rel=0`}
//                   title="ASSOCHAM Podcast"
//                   frameBorder="0"
//                   allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                   allowFullScreen
//                 ></iframe>
//               ) : (
//                 <img
//                   src={`https://img.youtube.com/vi/${currentVideo.id}/maxresdefault.jpg`}
//                   alt={currentVideo.title}
//                   className="w-full h-full object-cover"
//                 />
//               )}

//               {!isPlaying && (
//                 <div className="absolute inset-0 flex items-center justify-center bg-black/30 hover:bg-black/50 transition-all">
//                   <div className="w-20 h-20 bg-[#FFFFFF] rounded-full flex items-center justify-center shadow-xl">
//                     <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10 text-[#da2128] ml-1" fill="currentColor" viewBox="0 0 24 24">
//                       <path d="M8 5.14v14l11-7z" />
//                     </svg>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Progress Bar */}
//           <div className="h-1 bg-gray-100 mx-6 mt-2 rounded-full overflow-hidden">
//             <div
//               className="h-full bg-[#da2128] rounded-full transition-all"
//               style={{ animation: isHoveringPodcast ? "none" : "progress 5s linear infinite" }}
//             ></div>
//           </div>

          
//           <div className="flex-1 overflow-hidden relative py-5 px-6">
//             <div className="podcast-step-scroll p-2 space-y-4">
//               {[...PODCAST_VIDEOS, ...PODCAST_VIDEOS, ...PODCAST_VIDEOS].map((video, idx) => (
//                 <div
//                   key={idx}
//                   onClick={() => {
//                     setCurrentVideoIndex(PODCAST_VIDEOS.indexOf(video) % PODCAST_VIDEOS.length);
//                     setIsPlaying(false);
//                   }}
//                   className={`p-4 rounded-2xl cursor-pointer transition-all hover:bg-gray-50 ${
//                     video.id === currentVideo.id ? "bg-[#da2128]/5 ring-1 ring-[#da2128]/20" : ""
//                   }`}
//                 >
//                   <p className={`text-[14px] leading-snug transition-all font-rethink ${
//                     video.id === currentVideo.id
//                       ? "text-[#da2128] font-medium"
//                       : "text-neutral-700"
//                   }`}>
//                     {video.title}
//                   </p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* MIDDLE: UPCOMING EVENTS */}
//         <div className="lg:col-span-5 bg-[#ffffff] rounded-3xl p-6 shadow-xl flex flex-col" style={{ height: "520px" }}>
//           <div className="flex items-center justify-between mb-6">
//             <h3 className="text-[18px] font-semibold text-[#da2128] font-rethink">UPCOMING EVENTS</h3>
//             <a href="#" className="text-red-600 text-sm font-medium hover:underline">View All →</a>
//           </div>

//           <div className="space-y-6 flex-1 overflow-y-auto pr-2 custom-scrollbar">
//             {UPCOMING_EVENTS.map((event, index) => (
//               <div key={index} className="flex gap-4">
//                 <img 
//                   src={event.image} 
//                   alt={event.title} 
//                   className="w-24 h-20 object-cover rounded-xl flex-shrink-0" 
//                 />
//                 <div className="flex-1">
//                   <div className="text-xs text-gray-500">
//                     {event.month} <span className="font-bold text-gray-900">{event.date}</span>
//                   </div>
//                   <h4 className="font-semibold leading-tight mt-1 text-gray-900">
//                     {event.title}
//                   </h4>
//                   <p className="text-sm text-gray-600 mt-1">{event.location}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* RIGHT: FLAGSHIP */}
//         <div className="lg:col-span-3 bg-[#FFFFFF] rounded-3xl overflow-hidden shadow-xl flex flex-col">
//           <div className="relative h-[470px] overflow-hidden">
//             <img
//               src={FLAGSHIP_IMAGES[currentFlagshipIndex]}
//               alt="Flagship"
//               className="w-full h-full object-cover"
//             />

//             {/* ==================== ADDED FLAGSHIP TITLE ==================== */}
//             <div className="absolute top-1 left-1 bg-[#da2128]/80 text-white px-5 py-2 rounded-2xl shadow-lg z-10">
//               <h3 className="text-[14px] font-bold font-rethink tracking-tight">
//                 Flagship Initiatives
//               </h3>
//             </div>
//             {/* ======================================================== */}

//             <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#FFFFFF]/30">
//               <div className="h-1 bg-[#da2128] transition-all" style={{ width: `${flagshipProgress}%` }}></div>
//             </div>

//             <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2 z-20">
//               {FLAGSHIP_IMAGES.map((_, idx) => (
//                 <button
//                   key={idx}
//                   onClick={() => { setCurrentFlagshipIndex(idx); setFlagshipProgress(0); }}
//                   className={`w-3 h-3 rounded-full transition-all ${idx === currentFlagshipIndex ? 'bg-[#FFFFFF] scale-125' : 'bg-[#FFFFFF]/50'}`}
//                 />
//               ))}
//             </div>
//           </div>

//           <button className="w-full bg-[#dc262687] hover:bg-red-700 text-white py-4 font-medium transition-colors mt-auto rounded-bl-[10px] rounded-br-[10px]">
//             View More →
//           </button>
//         </div>
//       </div>

//       <style jsx>{`
//         .podcast-step-scroll {
//           animation: podcastStep 25s linear infinite;
//         }
//         @keyframes podcastStep {
//           0%, 18%    { transform: translateY(0); }
//           20%, 38%   { transform: translateY(-78px); }
//           40%, 58%   { transform: translateY(-156px); }
//           60%, 78%   { transform: translateY(-234px); }
//           80%, 98%   { transform: translateY(-312px); }
//           100%       { transform: translateY(-312px); }
//         }
//         .podcast-step-scroll:hover {
//           animation-play-state: paused;
//         }
//         @keyframes progress {
//           from { width: 0%; }
//           to { width: 100%; }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default FlagshipAndEvent;






// new code after feedback




import React, { useState, useEffect } from 'react';

const FLAGSHIP_IMAGES = [
  "https://assocham.org/assets/images/1739943966_SMK_2.0_ASSOCHAM%20Web%20Banner_650%20X%20914%20pixels.jpg",
  "https://assocham.org/assets/images/1772536051_Untitled%20design.jpg",
  "https://assocham.org/assets/images/1770812319_IMG-20260211-WA0043.jpg",
];

const PODCAST_VIDEOS = [
  { id: "U3JGpV6nI9Q", title: "ASSOCHAM Voice Podcast | Ep. 1" },
  { id: "VM_jpeUvfyw", title: "ASSOCHAM Voice Ep. 2" },
  { id: "Y7Rl-e_yJUk", title: "ASSOCHAM Voice Ep. 3" },
  { id: "pl3r5yT6I-0", title: "ASSOCHAM Voice Ep. 4" },
  { id: "Iwbt2yZaKSc", title: "ASSOCHAM Voice Ep. 5" },
];

const UPCOMING_EVENTS = [
  {
    image: "https://startupmahakumbh.org/assets/img/Logo-1.webp",
    month: "FEB",
    date: "12-14",
    title: "Startup Mahakumbh 2026",
    location: "Bharat Mandapam, New Delhi"
  },
  {
    image: "https://imgs.search.brave.com/NcI33rhygqZ1vWiqnhAyO5ad-ismIwvH56zn8jJPfzs/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly9pY2do/LmluL2xvZ2luL2lt/YWdlcy9CYW5uZXJf/LmpwZw",
    month: "JAN",
    date: "22",
    title: "National Summit on Green Hydrogen",
    location: "Mumbai"
  },
  {
    image: "https://imgs.search.brave.com/l9z5OGjIl1j3ZkvgbWN_aoeX6ziQenCcoEHkdBst43o/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9kMS5h/d3NzdGF0aWMuY29t/L29uZWRhbS9tYXJr/ZXRpbmctY2hhbm5l/bHMvd2Vic2l0ZS9h/d3MvZW5fVVMvZXZl/bnRzL2FwcHJvdmVk/L2ltYWdlcy9hd3Mt/YWktY29uY2xhdmUt/MjYtdmlkZW8uMWIx/NmE2Zjg3YWUzNGM0/YmE2N2JmYWU3OTM5/NWY3ZWM2ZTQ1ZTFh/My5qcGc",
    month: "MAR",
    date: "05",
    title: "Global AI Conclave 2026",
    location: "Bengaluru"
  },
  {
    image: "https://imgs.search.brave.com/s2KhPbYH_EuzKkJOBABX-h8SL_AKTXxM2Zyz6QQNpzY/rs:fit:500:0:1:0/g:ce/aHR0cHM6Ly93d3cu/c3lubmV4Z3JvdXAu/Y29tL3dwLWNvbnRl/bnQvdXBsb2Fkcy8y/MDI1LzA1L1RodW1i/bmFpbC0xNS0xLXNj/YWxlZC5qcGc",
    month: "APR",
    date: "15-16",
    title: "India Manufacturing Summit 2026",
    location: "Hyderabad International Convention Centre"
  }
];

const FlagshipAndEvent = () => {
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isHoveringPodcast, setIsHoveringPodcast] = useState(false);

  const [currentFlagshipIndex, setCurrentFlagshipIndex] = useState(0);
  const [flagshipProgress, setFlagshipProgress] = useState(0);

  const currentVideo = PODCAST_VIDEOS[currentVideoIndex];

  // Auto Slider for Podcast
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isHoveringPodcast) {
        setCurrentVideoIndex((prev) => (prev + 1) % PODCAST_VIDEOS.length);
        setIsPlaying(false);
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [isHoveringPodcast]);

  // Auto Slider for Flagship Images
  useEffect(() => {
    const interval = setInterval(() => {
      setFlagshipProgress((prev) => {
        if (prev >= 100) {
          setCurrentFlagshipIndex((prevIndex) => (prevIndex + 1) % FLAGSHIP_IMAGES.length);
          return 0;
        }
        return prev + 2;
      });
    }, 100);
    return () => clearInterval(interval);
  }, []);

  const handleVideoClick = () => {
    setIsPlaying(!isPlaying);
  };

  return (
    <div className="bg-[#fff8f5] py-12 px-4 font-sans">
      <div className="mx-auto text-center mb-10">
        {/* <h1 className="text-[26px] md:text-[28px] font-semibold leading-tight text-gray-900 font-rethink">
          <span className="text-[#da2128]">ASSOCHAM</span> Voice & Events
        </h1> */}
        <p className="text-[14px] text-gray-600 mt-3 max-w-2xl mx-auto leading-relaxed font-rethink">
          Stay updated with the latest discussions, upcoming programs and flagship initiatives.
        </p>
      </div>

      <div className="mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
        
        {/* LEFT: PODCAST */}
        <div className="lg:col-span-4 bg-[#ffffff] rounded-3xl shadow-xl flex flex-col h-[520px] overflow-hidden">
          <div className="p-6 border-b border-gray-100">
            <h3 className="text-[18px] font-semibold text-[#da2128] font-rethink text-center lg:text-left">
              ASSOCHAM Voice Podcast
            </h3>
          </div>

          {/* Video Container */}
          <div 
            className="px-5 pt-4 pb-3 bg-[#FFFFFF] cursor-pointer"
            onMouseEnter={() => setIsHoveringPodcast(true)}
            onMouseLeave={() => setIsHoveringPodcast(false)}
            onClick={handleVideoClick}
          >
            <div className="relative rounded-2xl overflow-hidden shadow-md h-[240px] bg-black ring-1 ring-gray-200">
              {isPlaying ? (
                <iframe
                  width="100%"
                  height="100%"
                  src={`https://www.youtube.com/embed/${currentVideo.id}?autoplay=1&rel=0`}
                  title="ASSOCHAM Podcast"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              ) : (
                <img
                  src={`https://img.youtube.com/vi/${currentVideo.id}/maxresdefault.jpg`}
                  alt={currentVideo.title}
                  className="w-full h-full object-cover"
                />
              )}

              {!isPlaying && (
                <div className="absolute inset-0 flex items-center justify-center bg-black/30 hover:bg-black/50 transition-all">
                  <div className="w-20 h-20 bg-[#FFFFFF] rounded-full flex items-center justify-center shadow-xl">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10 text-[#da2128] ml-1" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M8 5.14v14l11-7z" />
                    </svg>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Progress Bar */}
          <div className="h-1 bg-gray-100 mx-6 mt-2 rounded-full overflow-hidden">
            <div
              className="h-full bg-[#da2128] rounded-full transition-all"
              style={{ animation: isHoveringPodcast ? "none" : "progress 5s linear infinite" }}
            ></div>
          </div>

          <div className="flex-1 overflow-hidden relative py-5 px-6">
            <div className="podcast-step-scroll p-2 space-y-4">
              {[...PODCAST_VIDEOS, ...PODCAST_VIDEOS, ...PODCAST_VIDEOS].map((video, idx) => (
                <div
                  key={idx}
                  onClick={() => {
                    setCurrentVideoIndex(PODCAST_VIDEOS.indexOf(video) % PODCAST_VIDEOS.length);
                    setIsPlaying(false);
                  }}
                  className={`p-4 rounded-2xl cursor-pointer transition-all hover:bg-gray-50 ${
                    video.id === currentVideo.id ? "bg-[#da2128]/5 ring-1 ring-[#da2128]/20" : ""
                  }`}
                >
                  <p className={`text-[14px] leading-snug transition-all font-rethink line-clamp-1 ${
                    video.id === currentVideo.id
                      ? "text-[#da2128] font-medium"
                      : "text-neutral-700"
                  }`}>
                    {video.title}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* MIDDLE: UPCOMING EVENTS */}
        <div className="lg:col-span-5 bg-[#ffffff] rounded-3xl p-6 shadow-xl flex flex-col" style={{ height: "520px" }}>
          <div className="flex items-center justify-between mb-6 border-b border-gray-100 pb-4">
            <h3 className="text-[18px] font-semibold text-[#da2128] font-rethink">
              Forthcoming Events
            </h3>
            <a href="#" className="text-red-600 text-sm font-medium hover:underline">View All →</a>
          </div>

          <div className="space-y-6 flex-1 overflow-y-auto pr-2 custom-scrollbar">
            {UPCOMING_EVENTS.map((event, index) => (
              <div key={index} className="flex gap-4">
                <img 
                  src={event.image} 
                  alt={event.title} 
                  className="w-24 h-20 object-cover rounded-xl flex-shrink-0" 
                />
                <div className="flex-1 min-w-0">
                  <div className="text-xs text-gray-500">
                    {event.month} <span className="font-bold text-gray-900">{event.date}</span>
                  </div>
                  <h4 className="font-semibold leading-tight mt-1 text-gray-900 line-clamp-1">
                    {event.title}
                  </h4>
                  <p className="text-sm text-gray-600 mt-1 line-clamp-1">{event.location}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT: FLAGSHIP */}
        <div className="lg:col-span-3 bg-[#FFFFFF] rounded-3xl overflow-hidden shadow-xl flex flex-col">
          <div className="relative h-[470px] overflow-hidden">
            <img 
              src={FLAGSHIP_IMAGES[currentFlagshipIndex]}
              alt="Flagship"
              className="w-full h-full object-cover mt-[70px]"
            />

            <div className="absolute top-4 left-1 px-5 py-2.5 z-10">
            {/* <div className="absolute top-5 left-6 bg-[#da2128]/90 text-white px-5 py-2.5 rounded-2xl shadow-lg z-10"> */}
              <h3 className="text-[18px] text-[#da2128] font-semibold font-rethink tracking-tight">
              {/* <h3 className="text-[15px] font-semibold font-rethink tracking-tight"> */}
                Flagship
              </h3>
            </div>

            <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#FFFFFF]/30">
              <div className="h-1 bg-[#da2128] transition-all" style={{ width: `${flagshipProgress}%` }}></div>
            </div>

            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2 z-20">
              {FLAGSHIP_IMAGES.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => { setCurrentFlagshipIndex(idx); setFlagshipProgress(0); }}
                  className={`w-3 h-3 rounded-full transition-all ${idx === currentFlagshipIndex ? 'bg-[#FFFFFF] scale-125' : 'bg-[#FFFFFF]/50'}`}
                />
              ))}
            </div>
          </div>

          <button className="w-full bg-[#dc262694] hover:bg-red-700 text-white py-4 font-medium transition-colors mt-auto rounded-bl-[10px] rounded-br-[10px]">
            View More →
          </button>
{/* <div className="rounded-b-[20px] border-4 border-[#dc2626] overflow-hidden">
  <button className="w-full text-[#dc2626] hover:bg-[#dc2626] hover:text-white py-4 font-medium transition-colors">
    View More →
  </button>
</div> */}
        </div>
      </div>

      <style jsx>{`
        .podcast-step-scroll {
          animation: podcastStep 25s linear infinite;
        }
        @keyframes podcastStep {
          0%, 18%    { transform: translateY(0); }
          20%, 38%   { transform: translateY(-78px); }
          40%, 58%   { transform: translateY(-156px); }
          60%, 78%   { transform: translateY(-234px); }
          80%, 98%   { transform: translateY(-312px); }
          100%       { transform: translateY(-312px); }
        }
        .podcast-step-scroll:hover {
          animation-play-state: paused;
        }
        @keyframes progress {
          from { width: 0%; }
          to { width: 100%; }
        }
        .line-clamp-1 {
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </div>
  );
};

export default FlagshipAndEvent;